import ApiService from "@/common/api.service";
import { COMPANY_ID } from "@/common/config.js";
import JwtService from "@/common/jwt.service";
import jwtService from "../common/jwt.service";

import {
  PRODUCT_ADD_CART_SET_FORM,
  PRODUCT_DELETE_CART_SET_FORM,
  QUANTITY_CART_SET_FORM,
  TOTAL_CART_SET_FORM,
  ADD_CART,
  GET_CART,
  UPDATE_CART,
  ADD_LOCAL_CART,
  ADD_NEW_LOCAL_CART,
  SET_CART_FORM,
  CHECK_PRODUCT_LOCAL_CART,
  CHECK_CART,
  CHECH_PRODUCT_CART,
  DELETE_ITEM_CART_LOCAL,
  RESET_CART,
  UPDATE_ITEM_CART_LOCAL,
  GET_CART_LOCAL,
  MERGE_CART,
  CLEAR_CART_ACTION,
  UPDATE_QUANTITY_NOODLES,
  UPDATE_QUANTITY_GOODS,
  UPDATE_SIZE_NOODLES_LOCAL,
  UPDATE_SIZE_GOODS_LOCAL,
  UPDATE_OPTION_ITEM_CART_LOCAL,
  GET_CART_LOCAL_API
} from "./actions.type";
import {
  SET_PRODUCT_ADD_CART_FORM,
  SET_PRODUCT_EDIT_CART_FORM,
  SET_PRODUCT_DELETE_CART_FORM,
  SET_QUANTITY_CART_FORM,
  SET_TOTAL_CART_FORM,
  SET_CART_ERROR,
  SET_CART,
  SET_CART_LOCAL,
  CLEAR_CART,
  SET_QUANTITY_NOODLE,
  SET_QUANTITY_GOODS,
  SET_SIZE_NOODLES_LOCAL,
  SET_SIZE_GOODS_LOCAL,
  SET_CART_LOCAL_API
} from "./mutations.type";

const state = {
  errors: null,
  cart: null,
  total: null,
  cartLocal: null,
  cartLocalApi: null,
  sizeNoodle: 0,
  sizeGoods: 0,
  sizeNoodleLocal: 0,
  sizeGoodsLocal: 0
};
const getters = {
  cart(state) {
    return state.cart;
  },
  cartErrors(state) {
    return state.errors;
  },
  cartLocal(state) {
    return state.cartLocal;
  },
  sizeNoodle(state) {
    return state.sizeNoodle;
  },
  sizeGoods(state) {
    return state.sizeGoods;
  },
  sizeNoodleLocal(state) {
    return state.sizeNoodleLocal;
  },
  sizeGoodsLocal(state) {
    return state.sizeGoodsLocal;
  },
  cartTotal(state) {
    return state.total;
  },
  cartLocalApi(state) {
    return state.cartLocalApi;
  }
};

const actions = {
  [PRODUCT_ADD_CART_SET_FORM]({ commit, state }, payload) {
    const itemIndex = state.cart.findIndex(
      item => item.id === payload.id && item.combo === payload.combo
    );
    if (itemIndex === -1) {
      commit(SET_PRODUCT_ADD_CART_FORM, payload);
    } else {
      commit(SET_PRODUCT_EDIT_CART_FORM, { index: itemIndex, payload });
    }
  },
  [QUANTITY_CART_SET_FORM]({ commit }, params) {
    commit(SET_QUANTITY_CART_FORM, params);
  },
  [PRODUCT_DELETE_CART_SET_FORM]({ commit }, index) {
    commit(SET_PRODUCT_DELETE_CART_FORM, index);
  },
  [TOTAL_CART_SET_FORM]({ commit }, payload) {
    commit(SET_TOTAL_CART_FORM, payload);
  },
  [ADD_CART]({ commit, dispatch }, payload) {
    ApiService.post("v1/carts/with_option?offset=0&limit=100", payload)
      .then(() => {
        dispatch(GET_CART);
      })
      .catch(response => {
        commit(SET_CART_ERROR, response.data);
      });
  },
  [GET_CART]({ commit, dispatch }) {
    if (!jwtService.getToken()) {
      return;
    }
    return ApiService.get(
      "v1/carts",
      `${COMPANY_ID}/with_option?offset=0&limit=100`
    )
      .then(response => {
        commit(SET_CART_ERROR, null);
        commit(SET_CART, response.data);
      })
      .then(() => {
        dispatch(UPDATE_QUANTITY_NOODLES);
        dispatch(UPDATE_QUANTITY_GOODS);
      })
      .catch(response => {
        commit(SET_CART_ERROR, response.data);
      });
  },
  [SET_CART_FORM]({ commit }, payload) {
    commit(SET_CART, payload);
  },
  [UPDATE_CART]({ commit }, params) {
    if (!jwtService.getToken()) {
      return;
    }
    return ApiService.patch("v1/carts/with_option", params)
      .then(() => {
        dispatch(GET_CART);
      })
      .catch(response => {
        commit(SET_CART_ERROR, response.data);
      });
  },
  [CHECK_CART]({ state, dispatch }, payload) {
    !state.cart || !state.cart[0]
      ? dispatch(ADD_CART, payload)
      : dispatch(CHECH_PRODUCT_CART, payload);
  },
  [CHECH_PRODUCT_CART]({ dispatch, state }, payload) {
    if (state.cart && state.cart[0].products.length === 0) {
      dispatch(UPDATE_CART, payload).then(() => {
        dispatch(GET_CART);
      });
    } else {
      const cart_clone = { ...state.cart[0] };
      payload &&
        payload.products.forEach(item => {
          if (
            cart_clone.products.every(i => i.product_id !== item.product_id)
          ) {
            cart_clone.products.push(item);
          } else {
            const compareProductOptions = (listOption, listOption2) => {
              if (
                (!listOption || listOption.length == 0) &&
                (!listOption2 || listOption2.length == 0)
              )
                return true;
              if (!listOption || !listOption2) return false;
              return (
                listOption.every(item =>
                  listOption2.some(
                    item2 => item2.product_option_id === item.product_option_id
                  )
                ) &&
                listOption2.every(item2 =>
                  listOption.some(
                    item => item2.product_option_id === item.product_option_id
                  )
                )
              );
            };

            if (
              cart_clone.products.some(
                product =>
                  product.product_id === item.product_id &&
                  compareProductOptions(
                    product.product_options,
                    item.product_options
                  )
              )
            ) {
              const index = cart_clone.products.findIndex(
                product =>
                  product.product_id === item.product_id &&
                  compareProductOptions(
                    product.product_options,
                    item.product_options
                  )
              );
              // let sum = (cart_clone.products[index].count += item.count);
              // if (item.memo === "noodle") {
              //   cart_clone.products[index].count = sum > 3 ? 3 : sum;
              // } else {
              cart_clone.products[index].count += item.count;
              // }
            } else {
              cart_clone.products.push(item);
            }
            // } else {
            // const index = cart_clone.products.findIndex(
            // i => i.product_id === item.product_id
            // );

            // }
          }
        });
      dispatch(UPDATE_CART, cart_clone).then(() => {
        dispatch(GET_CART);
      });
    }
  },
  [ADD_LOCAL_CART]({ dispatch }, payload) {
    const cartLocal =
      JwtService.getCartLocal() && JSON.parse(JwtService.getCartLocal());

    if (cartLocal && cartLocal.length > 0) {
      if (
        cartLocal.some(
          item =>
            item.product_id == payload[0].product_id &&
            item.is_manage_stock &&
            item.stock < item.count + payload[0].count
        )
      )
        return;
      dispatch(CHECK_PRODUCT_LOCAL_CART, payload);
    } else if (!cartLocal || cartLocal.length == 0) {
      if (payload.length > 0 && payload[0].is_manage_stock) {
        const isMoreThanStock = payload[0].count > payload[0].stock;
        if (isMoreThanStock) return;
      }
      JwtService.setCartLocal(JSON.stringify(payload));
    }

    dispatch(GET_CART_LOCAL);
  },
  [ADD_NEW_LOCAL_CART]({ dispatch }, payload) {
    JwtService.setCartLocal(JSON.stringify(payload));
    dispatch(GET_CART_LOCAL);
  },
  [CHECK_PRODUCT_LOCAL_CART](_, payload) {
    let Cart = JSON.parse(JwtService.getCartLocal());
    if (Cart.length > 0) {
      payload.forEach(item => {
        if (Cart.every(i => i.product_id !== item.product_id)) {
          Cart.push(item);
        } else {
          const compareProductOptions = (listOption, listOption2) => {
            if (!listOption && !listOption2) return true;
            if (!listOption || !listOption2) return false;
            return (
              listOption.every(item =>
                listOption2.some(
                  item2 => item2.product_option_id === item.product_option_id
                )
              ) &&
              listOption2.every(item2 =>
                listOption.some(
                  item => item2.product_option_id === item.product_option_id
                )
              )
            );
          };
          // if (item.memo === "noodle") {
          if (
            Cart.some(
              product =>
                product.product_id === item.product_id &&
                compareProductOptions(
                  product.product_options,
                  item.product_options
                )
            )
          ) {
            const index = Cart.findIndex(
              product =>
                product.product_id === item.product_id &&
                compareProductOptions(
                  product.product_options,
                  item.product_options
                )
            );
            // let sum = (Cart[index].count += item.count);
            // if (item.memo === "noodle") {
            //   Cart[index].count = sum > 3 ? 3 : sum;
            // } else {
            Cart[index].count += item.count;
            // }
          } else {
            Cart.push(item);
          }
          // } else {
          // const index = Cart.findIndex(
          //   (i) => i.product_id === item.product_id
          // );
          // }
        }
      });
    } else {
      payload.forEach(item => Cart.push(item));
      JwtService.setCartLocal(JSON.stringify(Cart));
    }

    JwtService.setCartLocal(JSON.stringify(Cart));
  },
  [DELETE_ITEM_CART_LOCAL]({ dispatch }, index) {
    let Cart = JSON.parse(JwtService.getCartLocal());
    Cart.splice(index, 1);
    JwtService.setCartLocal(JSON.stringify(Cart));
    dispatch(GET_CART_LOCAL);
  },
  [RESET_CART]({ dispatch }) {
    JwtService.setCartLocal(JSON.stringify([]));
    dispatch(GET_CART_LOCAL);
    dispatch(UPDATE_CART, {
      company_id: COMPANY_ID,
      shipping: 100,
      products: []
    }).then(() => {
      dispatch(GET_CART);
    });
  },
  [UPDATE_ITEM_CART_LOCAL]({ dispatch }, { index, value }) {
    let Cart = JSON.parse(JwtService.getCartLocal());
    Cart[index].count = value;
    JwtService.setCartLocal(JSON.stringify(Cart));
    dispatch(GET_CART_LOCAL);
  },
  [UPDATE_OPTION_ITEM_CART_LOCAL](
    { dispatch },
    { index, index_option, count }
  ) {
    let Cart = JSON.parse(JwtService.getCartLocal());
    Cart[index].product_options[index_option].count = count;
    JwtService.setCartLocal(JSON.stringify(Cart));
    dispatch(GET_CART_LOCAL);
  },
  [GET_CART_LOCAL]({ commit }) {
    commit(SET_CART_LOCAL, JSON.parse(JwtService.getCartLocal()));
  },
  [MERGE_CART]({ dispatch }) {
    const cartLocal = JSON.parse(JwtService.getCartLocal());
    if (Array.isArray(cartLocal)) {
      dispatch(CHECK_CART, {
        company_id: COMPANY_ID,
        shipping: 100,
        products: cartLocal
      });
    }
    JwtService.destroyCartLocal();
  },
  [CLEAR_CART_ACTION]({ commit }) {
    commit(CLEAR_CART);
  },
  [UPDATE_QUANTITY_NOODLES]({ commit, rootState }) {
    const cart = rootState.cart.cart;
    let sum = 0;
    if (cart && cart[0]) {
      cart[0].products.forEach(item => {
        if (item.memo === "noodle") sum += item.count;
      });
    }
    commit(SET_QUANTITY_NOODLE, sum);
  },
  [UPDATE_QUANTITY_GOODS]({ commit, rootState }) {
    const cart = rootState.cart.cart;
    let sum = 0;
    if (cart && cart[0]) {
      cart[0].products.forEach(item => {
        if (item.memo === "goods") sum += item.count * item.size;
      });
    }
    commit(SET_QUANTITY_GOODS, sum);
  },

  [UPDATE_SIZE_NOODLES_LOCAL]({ commit }) {
    let Cart = JSON.parse(JwtService.getCartLocal());
    let sum = 0;
    if (Cart) {
      Cart.forEach(item => {
        if (item.memo === "noodle") sum += item.count;
      });
    }
    commit(SET_SIZE_NOODLES_LOCAL, sum);
  },
  [UPDATE_SIZE_GOODS_LOCAL]({ commit }) {
    let Cart = JSON.parse(JwtService.getCartLocal());
    let sum = 0;
    if (Cart) {
      Cart.forEach(item => {
        if (item.memo === "goods") sum += item.count * item.size;
      });
    }
    commit(SET_SIZE_GOODS_LOCAL, sum);
  },
  [GET_CART_LOCAL_API]({ commit }, payload) {
    return ApiService.get(
      "/v1/products",
      `guest/list_products?productIDs=${payload}`
    )
      .then(response => {
        commit(SET_CART_LOCAL_API, response.data);
        let Cart = JSON.parse(JwtService.getCartLocal());

        if (Cart && Cart.length > 0 && response.data) {
          const newCart = Cart.map(item => {
            let existed = response.data.find(i => i.id == item.product_id);

            if (existed) {
              item.purchase_limit = existed.purchase_limit;
            }
            return item;
          });
          JwtService.setCartLocal(JSON.stringify(newCart));
          dispatch(GET_CART_LOCAL);
        }
      })
      .catch(response => {
        commit(SET_CART_ERROR, response.data);
      });
  }
};

const mutations = {
  [SET_PRODUCT_ADD_CART_FORM](state, payload) {
    state.cart.push(payload);
  },
  [SET_PRODUCT_EDIT_CART_FORM](state, { index, payload }) {
    var quantity = state.cart[index].quantity + payload.quantity;
    state.cart[index] = { ...state.cart[index], quantity };
  },
  [SET_PRODUCT_DELETE_CART_FORM](state, index) {
    state.cart.splice(index, 1);
  },
  [SET_QUANTITY_CART_FORM](state, { index, quantity }) {
    state.cart[index] = { ...state.cart[index], quantity };
  },
  [SET_TOTAL_CART_FORM](state, payload) {
    state.total = payload;
  },
  [SET_CART_ERROR](state, payload) {
    state.errors = payload;
  },
  [SET_CART](state, payload) {
    state.cart = payload;
  },
  [SET_CART_LOCAL](state, payload) {
    state.cartLocal = payload;
  },
  [CLEAR_CART](state) {
    state.cart = null;
  },
  [SET_QUANTITY_NOODLE](state, value) {
    let size = 0;
    if (value === 1) size = 80;
    if (value === 2) size = 100;
    if (value >= 3) size = 120;
    state.sizeNoodle = size;
  },
  [SET_QUANTITY_GOODS](state, value) {
    state.sizeGoods = value;
  },
  [SET_SIZE_NOODLES_LOCAL](state, value) {
    let size = 0;
    if (value === 1) size = 80;
    if (value === 2) size = 100;
    if (value >= 3) size = 120;
    state.sizeNoodleLocal = size;
  },
  [SET_SIZE_GOODS_LOCAL](state, value) {
    state.sizeGoodsLocal = value;
  },
  [SET_CART_LOCAL_API](state, value) {
    state.cartLocalApi = value;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
